import React from 'react';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import Page from '../../Page';
import SummaryAppelsDeFonds from './SummaryAppelsDeFonds';
import TableAppelsDeFonds from './TableAppelsDeFonds';

const MonLogement = () => {

    const { lotCommercialActif } = useLotsCommerciaux();
    const { montantAppele, montantDu, montantEncaisse } = lotCommercialActif || {};

    return <Page title="Appels de fonds">

        <SummaryAppelsDeFonds
            montantAppele={montantAppele}
            montantDu={montantDu}
            montantEncaisse={montantEncaisse}
        />

        <TableAppelsDeFonds />

    </Page>;

};

export default MonLogement;